import React, { useState } from 'react';
import { toast } from 'sonner';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { FileSpreadsheet, FileText, Printer } from 'lucide-react';
import { Button } from '../../components/Button';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { NativeSelect } from '../../components/common/NativeSelect';
import { divisionVerification } from '../../data/dashboard';
import { trafficDivisions } from '../../data/cngs';
import { bnNum } from '../../utils/bn';
const reports = [{
  key: 'total',
  name: 'মোট নিবন্ধিত সিএনজি',
  value: '১৭,০০০',
  desc: 'বিভাগ ও স্ট্যাটাসভিত্তিক নিবন্ধন'
}, {
  key: 'qrIssue',
  name: 'QR ইস্যু রিপোর্ট',
  value: '১৫,৮৫০',
  desc: 'ইস্যুকৃত, প্রিন্টকৃত ও অপেক্ষমাণ স্টিকার'
}, {
  key: 'qrScan',
  name: 'QR স্ক্যান রিপোর্ট',
  value: '৭,৬৬০',
  desc: 'গত ৭ দিনের রোডসাইড স্ক্যান'
}, {
  key: 'driver',
  name: 'চালক যাচাই রিপোর্ট',
  value: '৩৮,৪১২',
  desc: 'নিবন্ধিত ও যাচাইকৃত চালক'
}, {
  key: 'expLicense',
  name: 'মেয়াদোত্তীর্ণ লাইসেন্স',
  value: '৬১২',
  desc: 'মেয়াদ শেষ ও ৩০ দিনে শেষ হবে'
}, {
  key: 'expFitness',
  name: 'মেয়াদোত্তীর্ণ ফিটনেস',
  value: '২৮৪',
  desc: 'ফিটনেস নবায়ন প্রয়োজন'
}, {
  key: 'unauth',
  name: 'অননুমোদিত চালক',
  value: '১৪৯',
  desc: 'রোডসাইডে শনাক্ত (চলতি মাস)'
}, {
  key: 'irreg',
  name: 'অনিয়ম রিপোর্ট',
  value: '৩৭১',
  desc: 'ধরন ও নিষ্পত্তির অবস্থা'
}, {
  key: 'division',
  name: 'ট্রাফিক বিভাগভিত্তিক রিপোর্ট',
  value: '৮ বিভাগ',
  desc: 'বিভাগওয়ারি তুলনামূলক চিত্র'
}];
export function Reports() {
  const [active, setActive] = useState('division');
  const current = reports.find(r => r.key === active) ?? reports[0];
  return <div data-id="element-1687" data-mp="3systedtxr0he">
      <PageHeader title="রিপোর্ট" subtitle="পরিচালনাগত ও ব্যবস্থাপনাগত রিপোর্ট — PDF, Excel ও প্রিন্ট" data-id="element-1688" data-mp="3sz2lq82gdjq9" />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1689" data-mp="2ln3gpnbdc41i">
        {reports.map(r => <button key={r.key} onClick={() => setActive(r.key)} className={`rounded-lg border bg-white p-4 text-left shadow-sm ${active === r.key ? 'border-navy-600 ring-2 ring-navy-100' : 'border-border hover:border-navy-300'}`} data-id="element-1690" data-mp="2hivsrscqis4c">
            <div className="flex items-start justify-between gap-2" data-id="element-1691" data-mp="2936i9dy71ykv">
              <div className="flex items-start gap-3" data-id="element-1692" data-mp="29598nz39dtq4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-navy-50 text-navy-700" data-id="element-1693" data-mp="2e1ggjxf7tfap"><FileText className="h-[18px] w-[18px]" data-id="element-1694" data-mp="20al3e8xooc1b" /></span>
                <div data-id="element-1695" data-mp="2090cctakvb87">
                  <p className="font-semibold text-navy-900" data-id="element-1696" data-mp="25236b2j9omox">{r.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-1697" data-mp="253eb95og80hm">{r.desc}</p>
                </div>
              </div>
              <span className="font-heading text-lg font-bold text-navy-800" data-id="element-1698" data-mp="1vbrqahmb6n1o">{r.value}</span>
            </div>
          </button>)}
      </div>

      <Panel className="mt-4" title={current.name} subtitle="সময়কাল: ০৬–১২ মার্চ ২০২৬ • নমুনা তথ্য" actions={<>
            <NativeSelect options={['সকল বিভাগ', ...trafficDivisions]} aria-label="বিভাগ" className="w-36" data-id="element-1700" data-mp="12p0gbem2wiq2" />
            <NativeSelect options={['গত ৭ দিন', 'চলতি মাস', 'গত ৩ মাস', 'কাস্টম']} aria-label="সময়কাল" className="w-32" data-id="element-1701" data-mp="xqqkd1sj5e3e" />
            <Button variant="outline" size="sm" onClick={() => toast.success(`${current.name}.pdf ডাউনলোড হচ্ছে`)} data-id="element-1702" data-mp="1bqrii9heu7f6"><FileText className="h-4 w-4 text-red-600" data-id="element-1703" data-mp="16q3ttugnm2o4" />PDF</Button>
            <Button variant="outline" size="sm" onClick={() => toast.success(`${current.name}.xlsx ডাউনলোড হচ্ছে`)} data-id="element-1704" data-mp="1lnmd4hakbno6"><FileSpreadsheet className="h-4 w-4 text-emerald-700" data-id="element-1705" data-mp="1gpku1wd4zocp" />Excel</Button>
            <Button variant="outline" size="sm" onClick={() => window.print()} data-id="element-1706" data-mp="1ug7wnzm0pye2"><Printer className="h-4 w-4" data-id="element-1707" data-mp="1ufoganc0ni25" />Print</Button>
          </>} data-id="element-1699" data-mp="1hda4wqjvlmmx">
        <div className="grid gap-6 xl:grid-cols-[1fr_1fr]" data-id="element-1708" data-mp="1qfe6t0p0m9ij">
          <div className="h-72" data-id="element-1709" data-mp="24e45gkrhgh90">
            <ResponsiveContainer data-id="element-1710" data-mp="24f5g4o4l71q7">
              <BarChart data={divisionVerification} margin={{
              left: -10
            }} data-id="element-1711" data-mp="24cazl7op2122">
                <CartesianGrid stroke="#eef1f5" vertical={false} data-id="element-1712" data-mp="1zhdpdxfohlnl" />
                <XAxis dataKey="division" tick={{
                fontSize: 12
              }} axisLine={false} tickLine={false} data-id="element-1713" data-mp="2jgm3lwukdtn8" />
                <YAxis tick={{
                fontSize: 11
              }} axisLine={false} tickLine={false} data-id="element-1714" data-mp="2ni7c7602flrm" />
                <Tooltip formatter={(v: number, n: string) => [bnNum(v), n === 'scans' ? 'স্ক্যান' : 'অনিয়ম']} data-id="element-1715" data-mp="2s9pb7oij3c9y" />
                <Bar dataKey="scans" fill="#0b2e5f" radius={[3, 3, 0, 0]} data-id="element-1716" data-mp="2x80m82kk7str" />
                <Bar dataKey="issues" fill="#c62828" radius={[3, 3, 0, 0]} data-id="element-1717" data-mp="20jb368x74u67" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table className="w-full text-sm" data-id="element-1718" data-mp="24kobqqrobbgt">
            <thead className="bg-slate-50 text-left text-xs text-slate-500" data-id="element-1719" data-mp="29iy6j09hka1w">
              <tr data-id="element-1720" data-mp="29lu1cfq1eim4">{['ট্রাফিক বিভাগ', 'নিবন্ধিত সিএনজি', 'আজ স্ক্যান', 'অনিয়ম', 'অনিয়ম হার'].map(h => <th key={h} className="px-3 py-2 font-medium" data-id="element-1721" data-mp="2eg7s24tr81kg">{h}</th>)}</tr>
            </thead>
            <tbody data-id="element-1722" data-mp="3l0qua0pcdryr">
              {divisionVerification.map((d, i) => <tr key={d.division} className="border-t border-border" data-id="element-1723" data-mp="3pw66ko7pbft2" data-mpi={i}>
                  <td className="px-3 py-2 font-medium" data-id="element-1724" data-mp="1eank16h7cc18">ট্রাফিক-{d.division}</td>
                  <td className="px-3 py-2" data-id="element-1725" data-mp="19bkm05zn362r">{bnNum([1980, 1620, 2240, 1850, 2310, 2680, 2140, 2180][i])}</td>
                  <td className="px-3 py-2" data-id="element-1726" data-mp="14k2qvykarzpp">{bnNum(d.scans)}</td>
                  <td className="px-3 py-2 text-red-700" data-id="element-1727" data-mp="14i82ubdqbrhe">{bnNum(d.issues)}</td>
                  <td className="px-3 py-2" data-id="element-1728" data-mp="zl7wdzcywmpr">{bnNum(Number((d.issues / d.scans * 100).toFixed(1)))}%</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>;
}